import { render, staticRenderFns } from "./ProspectiveStudentCardMoreButton.vue?vue&type=template&id=7934814e"
import script from "./ProspectiveStudentCardMoreButton.vue?vue&type=script&lang=js"
export * from "./ProspectiveStudentCardMoreButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports